@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.Color {
  @extend %font-family-primary;

  &.inline-flex {
    display: inline-flex;
  }

  &.inline {
    display: inline;
  }

  &.purple {
    color: $color-primary-purple;
  }

  &.lightPurple {
    color: $color-action-snippetenabled;
  }

  &.darkPurple {
    color: $color-action-submodel;
  }

  &.blue {
    color: $color-state-default;
  }

  &.lightblue {
    color: $color-action-back;
  }

  &.darkBlue {
    color: $color-action-exit;
  }

  &.teal {
    color: $color-primary-green;
  }

  &.red {
    color: $color-primary-red;
  }

  &.redHover {
    color: $color-primary-red-hover;
  }

  &.highlightred {
    color: $color-highlight-red;
  }

  &.orange {
    color: $color-warning-orange;
  }

  &.violet {
    color: $color-state-global;
  }

  &.green {
    color: $color-alert-green-border;
  }

  &.secondarygreen {
    color: $color-secondary-green;
  }

  &.black {
    color: $color-primary-black;
  }

  &.gray {
    color: $color-grey-disabled;
  }

  &.greyA {
    color: $color-grey-A;
  }

  &.greyB {
    color: $color-grey-B;
  }

  &.greyC {
    color: $color-grey-C;
  }

  &.lightGray {
    color: $color-action-default;
  }

  &.stateGray {
    color: $color-grey-D;
  }

  &.greyDivider {
    color: $color-secondary-button-hover;
  }

  strong {
    font-weight: $font-weight-semibold;
  }

  &.theme-filter-icon {
    color: $theme-filter-icon-color;
  }

  &.theme-delete-danger {
    color: $theme-stop-icon-color;
  }

  &.theme-color-statuschip-text {
    color: $theme-color-statuschip-text;
  }

  &.theme-color-id {
    color: $theme-color-id;
  }

  &.theme-placeholder-text {
    color: $theme-placeholder-text;
  }

  &.theme-description-text {
    color: $theme-filter-icon-color;
  }

  &.theme-drag-and-drop-box-icon-color {
    color: $theme-drag-and-drop-box-icon-color;
  }

  &.theme-color-tab-label-unselected {
    color: $theme-color-tab-label-unselected;
  }

  &.form-alert-text-color {
    color: $theme-color-table-text;
  }

  &.theme-color-readonly-field-text {
    color: $theme-color-readonly-field-text;
  }

  &.theme-color-checkbox-border {
    color: $theme-color-checkbox-border;
  }

  &.theme-color-links {
    color: $theme-color-links;
  }

  &.theme-progress-flow-text {
    color: $theme-progress-flow-text-color;
  }

  &.theme-color-dnd-icon {
    color: $theme-color-dnd-icon;
  }

  &.theme-progress-flow-background-color {
    color: $theme-color-checkbox-border;
  }

  &.theme-color-text {
    color: $theme-color-text;
  }

  &.theme-test-case-global-icon-color {
    color: $theme-test-case-global-icon-color;
  }

  &.theme-remove-chip {
    color: $theme-color-button-remove-chip;
  }

  &.theme-header-label-text {
    color: $theme-header-label-text;
  }

  &.theme-color-tooltip {
    color: $theme-color-background;
  }
}
